import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.504 2.136a1 1 0 0 0-1.008 0l-12 7a1 1 0 0 0 0 1.728l12 7a1 1 0 0 0 1.008 0l12-7a1 1 0 0 0 0-1.728zM16 15.842 5.985 10 16 4.158 26.015 10z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M3.136 15.496a1 1 0 0 1 1.368-.36L16 21.842l11.496-6.706a1 1 0 0 1 1.008 1.728l-12 7a1 1 0 0 1-1.008 0l-12-7a1 1 0 0 1-.36-1.368"
    />
    <path
      fill="currentColor"
      d="M3.136 21.496a1 1 0 0 1 1.368-.36L16 27.842l11.496-6.706a1 1 0 0 1 1.008 1.728l-12 7a1 1 0 0 1-1.008 0l-12-7a1 1 0 0 1-.36-1.368"
    />
  </svg>
);
const SvgIconStack = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconStack);
export default Memo;
